export default __webpack_public_path__ + "static/media/strikethrough.3d51508f.svg";